import { ComponentChildren } from 'preact';

type Props = {
  children: ComponentChildren;
  id?: string;
};

export function OfferCard({ children, id }: Props) {
  return (
    <div
      id={id}
      class="max-w-2xl mx-auto rounded-2xl px-8 py-6 my-2"
      style="background: linear-gradient(180deg, var(--m-bg-subtle, #f5f7fa) 0%, #ffffff 100%)"
    >
      {children}
    </div>
  );
}
